export const clamp = (value: number, min: number, max: number): number => {
  return Math.min(Math.max(value, min), max);
};

export const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const cleaned = hex.replace('#', '');
  const value = parseInt(cleaned, 16);
  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  };
};

export const rgbToHex = (r: number, g: number, b: number): string => {
  return `#${[r, g, b].map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
};

export const interpolateHexColor = (startHex: string, endHex: string, t: number): string => {
  const start = hexToRgb(startHex);
  const end = hexToRgb(endHex);
  const mix = (from: number, to: number) => Math.round(from + (to - from) * t);
  return rgbToHex(mix(start.r, end.r), mix(start.g, end.g), mix(start.b, end.b));
};

export const getGradientColor = (
  value: number,
  min: number,
  max: number,
  startHex: string,
  endHex: string
): string => {
  const t = (clamp(value, min, max) - min) / (max - min);
  return interpolateHexColor(startHex, endHex, t);
};
